import { type FC, useState } from 'react';
import { useSelector } from 'react-redux';
import ModalWindow from '@editor2/components/ModalWindow';
import { type RootState } from '@editor2/reducers/root';
import { modalStyles } from './styles';
import Navigation from './Navigation';
import ConflictBlock from './ConflictBlock';
import ConflictsResolvedView from './conflictView/ConflictsResolvedView';

interface Props {
	isShown: boolean;
	courseId: number;
	onHide: () => void;
	setSaveChangesModalShown: (_: boolean) => void;
}

const ConflictResolutionModal: FC<Props> = (props) => {
	const { isShown, courseId, onHide } = props;

	const { conflicts } = useSelector((state: RootState) => state.courses[courseId]);

	const [currentConflictIndex, setCurrentConflictIndex] = useState(0);

	const title = <div>Conflicts to resolve</div>;
	const footer = <></>;

	const getCurrentConflictIndex = () => {
		return currentConflictIndex >= conflicts.length - 1
			? conflicts.length - 1
			: currentConflictIndex;
	};

	return (
		<ModalWindow
			isShown={isShown}
			onHide={onHide}
			title={title}
			footer={footer}
			modalStyles={modalStyles}>
			{!!conflicts?.length && (
				<>
					<div className="navigationBlock">
						<Navigation
							currentIndex={getCurrentConflictIndex()}
							conflictsNumber={conflicts.length}
							setCurrentIndex={setCurrentConflictIndex}
						/>
					</div>

					<ConflictBlock conflict={conflicts[getCurrentConflictIndex()]} courseId={courseId} />
				</>
			)}

			{!conflicts?.length && <ConflictsResolvedView />}
		</ModalWindow>
	);
};

export default ConflictResolutionModal;
